export default "__VITE_ASSET__sgU9kE6o__"